import React from 'react';
import { useForm, } from 'react-hook-form';
const FormContext = React.createContext(null);
/**
 * This creates an instance of <form /> that you can use Primitive Input, Select, Checkbox, Radio, etc elements in.
 * It wraps form elements in a React Context and a form tag so that you can access values and error messages anywhere
 * within your form. React-Hook-Form is used underneath.
 * @alias FormProviderProps
 * */
const FormProvider = React.forwardRef(({ children, onSubmit, values, disabled, ...rest }, ref) => {
    const { register, handleSubmit, control, formState: { errors }, setValue, getValues, reset, trigger, watch, setError, clearErrors, } = useForm();
    /*React.useEffect(() => {
        watch((x) => {
            console.log(x)
        })
    }, [])*/
    // Avoiding useMemo here as it interferes with error messages from hook form because
    // shallow compare won't go deep enough to differentiate
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const value = {
        register, control, handleSubmit, errors, setValue, getValues, reset, trigger, watch, setError, clearErrors
    };
    const valueComparator = JSON.stringify(values);
    React.useEffect(() => {
        if (values) {
            Object.entries(values).forEach(([k, v]) => {
                setValue(k, v);
            });
        }
        // eslint-disable-next-line
    }, [valueComparator]);
    return (React.createElement(FormContext.Provider, { value: value },
        React.createElement("form", { ref: ref, onSubmit: handleSubmit(onSubmit), style: {
                pointerEvents: disabled ? 'none' : 'auto',
                opacity: disabled ? '0.7' : '1',
            }, ...rest },
            React.createElement("fieldset", { disabled: disabled, "aria-disabled": disabled, 
                /*
                * Little hack to make it WAI-ARIA and disable
                * for non-mouse users, without adding another layer of style
                * */
                style: { display: 'contents' } }, children))));
});
FormProvider.displayName = 'FormProvider';
export default FormProvider;
/**
 * This will give you access to a FormProvider parent's values
 * if it exists. It is not guaranteed to exist,
 * so check if it returns values before using.
 * */
export const useFormProvider = () => React.useContext(FormContext);
//# sourceMappingURL=index.js.map